import { render, staticRenderFns } from "./inscription.vue?vue&type=template&id=faaf3a62&"
import script from "./inscription.vue?vue&type=script&lang=js&"
export * from "./inscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports